<template>
  <div>
    <div class="cards-container" v-if="this.$route.name === 'series'">
      <card-base v-for="serie in popularSeries" :key="serie.id">
        <div class="card-container" @click="goTo(serie.id)">
          <div class="card-image">
            <img :src="'https://image.tmdb.org/t/p/original' + serie.poster_path" :alt="serie.name">
          </div>
          <div class="card-body">
            <h2>{{ serie.name }}</h2>
            <p>{{ serie.overview }}</p>
          </div>
        </div>
      </card-base>
    </div>
    <pagination-base v-model="page" :records="500" @paginate="setPage(page)" /> 
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        popularSeries: [],
        page: 1,
      };
    },
    created() {
      fetch(`https://api.themoviedb.org/3/tv/popular?api_key=7e87347114ccb7e8746f73f84d249ab2&language=en-US&page=${this.page}`)
        .then(
          (response) => {
            response.json()
              .then(
                (data) => {
                  this.popularSeries = data.results;
                }
              )
          }
        )
    },
    methods: {
      goTo(serieId) {
        this.$router.push({path:'/series/' + serieId});
      },
      setPage(page) {
        this.page = page;
        fetch(`https://api.themoviedb.org/3/tv/popular?api_key=7e87347114ccb7e8746f73f84d249ab2&language=en-US&page=${this.page}`)
        .then(
          (response) => {
            response.json()
              .then(
                (data) => {
                  this.popularSeries = data.results;
                }
              )
          }
        )
        window.scrollTo(0,0);
      },
    },
  };
</script>

<style scoped>
  .cards-container {
    margin-top: 52px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .card-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .card-image img {
    width: 400px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }

  .card-body {
    height: 100%;
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .card-body h2 {
    min-height: 60px;
    padding-bottom: 8px;
    text-align: center;
    text-transform: uppercase;
    border-bottom: 1px solid #0C1E7F;
  }

  .card-body p {
    text-align: justify;
  }

  @media (max-width: 499px) {
    .cards-container {
      margin-top: 60px;
    }

    .card-image img {
      width: 300px;
    }

    .card-body {
      padding: 8px 16px;
    }

    .card-body h2 {
      min-height: 0;
      font-size: 16px;
    }

    .card-body p {
      font-size: 12px;
    }
  }
</style>
